import React from "react";
import {TextField, Typography} from "@mui/material";
import {forms, objects, strings} from "@atttomyx/shared-utils";

const TypeForm = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.title);

        onSync(modified);
    };

    return <div className="category-form">
        <Typography variant="h5">
            General
        </Typography>
        <div className="field top-margin">
            <TextField
                required={true}
                label="Title"
                type="text"
                value={forms.sanitizeValue(data.title)}
                onChange={(event) => onChange("title", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Description"
                type="text"
                multiline={true}
                value={forms.sanitizeValue(data.description)}
                onChange={(event) => onChange("description", event.target.value)}
            />
        </div>
    </div>
}

export default TypeForm;
